import styles from "./Progress.module.scss";
import { GreetingsHeader } from '../../components/common/GreetingsHeader';
import { useQuery } from '@apollo/client';
import { ASSESSMENTS_MINIMAL } from '../../apollo/queries';
import { useState } from 'react';
import Select from 'react-select';
import moment from 'moment';


export const Progress  = () => {
    const [assessments, setAssessments] = useState<[]>([]);
    const [selectedPdfUrl, setSelectedPdfUrl] = useState<string | undefined>(undefined);
    const [options, setOptions] = useState<[{label:String, value: String|Number}] | []>([]);

    useQuery(ASSESSMENTS_MINIMAL, {
        onCompleted: (someData) => {
            // @ts-ignore
            let subset = someData.assessmentsMinimal.map((assessment) => {
                return {
                    label: `${assessment.venture} - ${moment(assessment.completionTime).format('YYYY-MM-DD HH:mm')} (${assessment.scanType})`,
                    value: assessment.pdfUrl && assessment.pdfUrl.includes('http') ? assessment.pdfUrl : process.env.REACT_APP_STORAGE_URL + assessment.pdfUrl
                }
            })
            subset = subset.reverse()
            if(subset.length > 0) {
                // @ts-ignore
                setSelectedPdfUrl(subset[0].value)
            }
            setOptions(subset)
            setAssessments(someData.assessmentsMinimal)
        },
        fetchPolicy: "no-cache"
    });


    return (
        <div className={styles.wrapper}>
            <GreetingsHeader title="Select a scan to check the progress" subtitle=''/>
            <section className={styles.cardWrapper}>
                { options.length > 0 &&
                    <Select options={options} className="basic-single" classNamePrefix="select" defaultValue={options[0]} onChange={
                        // @ts-ignore
                        (e) => setSelectedPdfUrl(e.value)
                    }/>
                }
                <br/>
                <iframe src={selectedPdfUrl} style={{width: '100%', height: "100vh"}}/>

            </section>
        </div>
    )
};
